import './public-path'
import { createApp, watch } from 'vue'
import App from './App.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import router from './router'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
// import { ant } from './plugins/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import { createPinia } from 'pinia'
import './styles/index.less'
import './icons'
import * as Sentry from '@sentry/vue'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { useStore } from './store'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Report from '@dbt/report'

const pinia = createPinia()

const app = createApp(App)

const checkPermission = (el: any, binding: any) => {
  const store = useStore()
  const userInfo = store.getParsedUserInfo
  if (!userInfo) {
    el.style.display = 'none'
    return
  }

  const permissions = userInfo.permissions
  const permissionValue = binding.value?.permissionValue

  // 如果有完全权限(*) 则显示
  if (permissions?.some((item: string) => item === '*')) {
    el.style.display = ''
    return
  }

  // 检查具体权限
  const hasPermission = permissions?.some((item: string) => {
    const parts = item.split(':')
    const itemBtnType = parts[parts.length - 1]
    return (
      item === '*' ||
      item === permissionValue ||
      (parts[0] === permissionValue && (itemBtnType === '*' || itemBtnType === binding.value?.btnType))
    )
  })

  el.style.display = hasPermission ? '' : 'none'
}

// 针对页面中的操作增加了权限判断 读、读写权限
// 两个传值 permissionValue:对应页面 按钮类型 btnType
app.directive('permission', {
  mounted(el, binding) {
    const store = useStore()
    // 初始检查
    checkPermission(el, binding)

    // 监听 userInfo 变化
    watch(
      () => store.getParsedUserInfo,
      () => checkPermission(el, binding),
      { immediate: true },
    )
  },

  // 组件更新时重新检查权限
  updated(el, binding) {
    checkPermission(el, binding)
  },
})
// input 输入限制前后空格 换行
app.directive('no-spaceAline', {
  mounted(el) {
   el.addEventListener('input', function (event: Event) {
     const target = event.target as HTMLInputElement;
     target.value = target.value.trim().replace(/\n/g, '');
     target.dispatchEvent(new Event('input'));
   });

   el.addEventListener('blur', function (event: Event) {
     const target = event.target as HTMLInputElement;
     target.value = target.value.trim().replace(/\n/g, '');
     target.dispatchEvent(new Event('input'));
   });
  }
});


// 发新版后旧 hash 的 JS/CSS 被覆盖，停留在老页面的用户切换路由会触发 chunk 404，
// 属于已知的发布态噪音，不上报 Sentry。
// 注意：webpack 4 抛的是 `Loading chunk 23 failed.`，`ChunkLoadError` 是 webpack 5 的错误名，两者都要覆盖；
// 不要加 g 标志，否则 lastIndex 状态会导致漏匹配。
const CHUNK_ERROR_PATTERN = /ChunkLoadError|Loading (?:CSS )?chunk [\w-]+ failed/i

if (process.env.VUE_APP_IS_SENTRY === 'true') {
  Sentry.init({
    app,
    dsn: 'https://9127f634979d4baef5cb1c1e918f010c@sentry.wedobest.com.cn/7',
    release: process.env.VUE_APP_VERSION,
    ignoreErrors: [CHUNK_ERROR_PATTERN],
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost',
          'https://payadmin.wedobest.com.cn:8450',
          'https://payadmin.wedobest.com.cn',
          'https://gateway.wedobest.com.cn:8465',
        ],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.use(router)
app.use(Antd)
app.use(pinia)
app.use(VxeUITable)
router.isReady().then(() => {
  app.mount('#app')
})

// 添加全局的beforeunload监听器
window.addEventListener('beforeunload', () => {
  Report.clearPreviousObservers()
  console.log('应用关闭，性能监控已清理')
})
